import React, { useState } from 'react';
import { Button, Input, Tooltip } from 'antd';
import { LockOutlined, SendOutlined } from '@ant-design/icons';

const SOON_LABEL = 'Bientôt disponible';
// Limit of the mockup; the mobile composer (ConversationChatInput) allows 1500
const SMS_MAX_LENGTH = 1200;

interface ConversationComposerProps {
  isOwn: boolean;
  ownerLabel: string;
}

// Sending is not open yet on the web: the draft is typed but the buttons stay disabled
const ConversationComposer: React.FC<ConversationComposerProps> = ({ isOwn, ownerLabel }) => {
  const [draft, setDraft] = useState('');

  return (
    <div className="conversations__composer">
      {!isOwn && (
        <div className="contacts__read-only-banner conversations__read-only-banner">
          <LockOutlined />
          <span>
            <strong>Lecture seule</strong> · ligne de {ownerLabel}. L'envoi de SMS est réservé au propriétaire de cette ligne.
          </span>
        </div>
      )}
      <Input.TextArea
        className="conversations__composer-input"
        placeholder={isOwn ? 'Écrivez votre message…' : 'Envoi indisponible sur cette ligne'}
        autoSize={{ minRows: 2, maxRows: 6 }}
        maxLength={SMS_MAX_LENGTH}
        disabled={!isOwn}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
      />
      <div className="conversations__composer-footer">
        <span className="conversations__composer-count">
          {draft.length} / {SMS_MAX_LENGTH.toLocaleString('fr-FR')}
        </span>
        <div className="conversations__composer-actions">
          <Tooltip title={SOON_LABEL}>
            <Button disabled>Proposer un SMS</Button>
          </Tooltip>
          <Tooltip title={SOON_LABEL}>
            <Button type="primary" icon={<SendOutlined />} disabled>
              Envoyer
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default ConversationComposer;
